import { Injectable } from '@angular/core';
import { REPORT_CONFIG, ReportConfig } from '../REPORT_CONFIG';
import { TabbedFilterItem } from '../TABBED_FILTERS_CONFIG';
import { UtilFunctions } from '../../util-functions';
import { User } from 'app/models/User';

@Injectable()
export class DiscoveryService {
  constructor(private _userService: User) {}

  generateReportConfigs() {
    const reportConfigs = [];
    REPORT_CONFIG.forEach(config => {
      const currentConfig: ReportConfig = {
        key: config.key,
        title: config.title,
        viewDetailsText: config.viewDetailsText,
        mainFilterItems: [],
        gridHeaders: [],
        disabled:
          config.permission &&
          !this._userService.hasPermission(config.permission),
        topLevelCategories: config.topLevelCategories,
        permission: config.permission,
        importParams: config.importParams
      };
      reportConfigs.push(currentConfig);
    });
    console.log('REPORT CONFIGS: ', reportConfigs);
    return reportConfigs;
  }

  deselectAllFilters(reportConfig: ReportConfig) {
    reportConfig.topLevelCategories.forEach(topLevelCategory => {
      topLevelCategory.groups.forEach(tabbedGroup => {
        tabbedGroup.selected = false;
        tabbedGroup.items.forEach(item => {
          item.selected = false;
          item.options.forEach(option => {
            option.selected = false;
          });
        });
      });
    });
  }

  selectFilterFromKey(reportConfig: ReportConfig, key: string) {
    let foundItem = null;
    reportConfig.topLevelCategories.forEach(topLevelCategory => {
      topLevelCategory.groups.forEach(tabbedGroup => {
        tabbedGroup.items.forEach(item => {
          if (item.param === key) {
            foundItem = item;
            tabbedGroup.selected = true;
            item.selected = true;
          }
        });
      });
    });
    return foundItem;
  }

  initializeRangeValue(rangeValue: string, foundItem: TabbedFilterItem) {
    const rangeValues = rangeValue.split(',');
    foundItem.fromValue = Number.parseFloat(rangeValues[0]);
    foundItem.toValue = Number.parseFloat(rangeValues[1]);

    if (foundItem.rangePercent) {
      foundItem.fromValue = Number.parseFloat(
        Number.parseFloat(`${foundItem.fromValue * 100}`).toFixed(2)
      );
      foundItem.toValue = Number.parseFloat(
        Number.parseFloat(`${foundItem.toValue * 100}`).toFixed(2)
      );
    }
  }

  generateMultipleValues(queryValue: string, foundItem: TabbedFilterItem) {
    let values = [];
    if (foundItem.type === 'range') {
      values = queryValue.split('],[');
    } else {
      if (queryValue.indexOf('()')) {
        values = queryValue.split('()');
      } else {
        values = queryValue.split(',');
      }
    }
    return values;
  }

  generateRangeValue(foundItem: TabbedFilterItem) {
    let valueLabel = null;
    if (foundItem.rangePercent) {
      const fromLabel = Number.parseFloat(`${foundItem.fromValue}`).toFixed(2);
      const toLabel = Number.parseFloat(`${foundItem.toValue}`).toFixed(2);
      valueLabel = `${fromLabel}% - ${toLabel}%`;
    } else {
      if (foundItem.labelFormat) {
        const fromLabel: string = UtilFunctions.formatValue(
          foundItem.fromValue,
          foundItem.labelFormat
        ).toUpperCase();
        const toLabel: string = UtilFunctions.formatValue(
          foundItem.toValue,
          foundItem.labelFormat
        ).toUpperCase();
        valueLabel = `${fromLabel} - ${toLabel}`;
      } else {
        valueLabel = `${foundItem.fromValue} - ${foundItem.toValue}`;
      }
    }
    return valueLabel;
  }
}
